/* eslint-disable */
import MemberAdmin from './state';
export default {
  MemberAdmin,
};
